module.exports = __webpack_public_path__ + "static/media/preplay-plus-blue.bb8beed7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-plus-blue.svg
// module id = ./src/assets/images/preplay-plus-blue.svg
// module chunks = 0